import {html} from 'lit-html';

import TemplateRegistry from '../template/template-registry';
import FontLoader from '../font-loader';

TemplateRegistry.templates['font'] = (option, config, onChange) => {

    let fontFamilies;

    // filtered font families or all fonts from Font library
    if(option.params.fontFamilies && option.params.fontFamilies.length){
        fontFamilies = option.params.fontFamilies;
    } else {
        fontFamilies = FontLoader.fonts.map(font => font.name);
    }

    // NEW: client side font sort
    if(option.params.fontSortAlpha){
        fontFamilies.sort((a, b) => a.localeCompare(b))
    }

    option.values = fontFamilies.map((fontFamily) => {
        return {
            value: fontFamily,
            text: ' ', // empty text to only render img
            img: FontLoader.fontPreview(fontFamily)
        }
    });

    let template = 'dropdown';

    // NEW: font img swatch support
    if(option.params.fontSwatch){
        option.params.grow = true;  // implicit grow items
        option.params.items = option.params.fontSwatchItems || 3; // default 3 items
        template = 'img-swatch';
    }

    // wrap option with div and custom class
    return html`
        <div class="cl-po--font-selector">
              ${TemplateRegistry.templates[template](option, config, onChange)}
        </div>
    `;
}